import React from 'react';
import { powerPlants } from '../../actions/powerPlantsArray';

export class Destroyservice extends React.Component {
  constructor(props){
    super(props);

    this.state = {
      selected: this.props.object,
      price: 0,
      netPrice: 0,
      mutualBuy: false,
      entity: false
    };
  }

  createAlert = (msg) => {
    this.props.createAlert(msg);
  }

  componentDidMount(){
    if(this.props.external === true) {
      const plotId = this.props.object.id;

      let plant;
      let mutualBuy;
      if(this.props.internal === false){
        plant = powerPlants.find((current) => { return current.id === plotId });
        mutualBuy = (typeof(plant.purchasedBy) === "string"  ? false : plant.purchasedBy[1]);
      } else {
        plant = this.props.object;
        mutualBuy = false;
      }

      this.setState({
        selected: plant.name,
        price: plant.basePrice,
        netPrice: (mutualBuy === false ? plant.basePrice / 2 : plant.basePrice / 2 / 2),
        entity: mutualBuy
      })
    }
  }

  handleDemolish = (e) => {
    e.preventDefault();
    const data = {
      name: this.state.selected,
      buyWith: this.state.entity
    };

    this.props.callbackDemolish(data);
  }

  getMutualPrice = () => {
    if(this.state.entity !== false){
      return(
        <div className="formRow">
          <label>Kosten per speler (&euro;)</label>
          <input type='text' value={Math.floor(this.state.netPrice)} readOnly="true"/>
        </div>
      )
    }
  }

  render(){
    return (
      <form>
        <div className="formRow">
          <h2>Sloop centrale</h2>
        </div>
        <div className="formRow">
          <label>Te slopen centrale</label>
          <input type='text' readOnly="true" value={this.state.selected}/>
        </div>
        <div className="formRow">
          <label>Kosten (&euro;)</label>
          <input type='text' value={Math.floor(this.state.netPrice)} readOnly="true"/>
        </div>
        {this.getMutualPrice()}
        <div className="dealButton" onClick={this.handleDemolish}>
          <img alt="dealButton" src={require("../../assets/elements/Icon - destroy.svg")}/>
          <div className="text">Sloop centrale</div>
        </div>
      </form>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/interactive/destroyService.js